import NelQualityAlertForm from './NelQualityAlertForm';
import NclFeedbackAlertForm from './NclFeedbackAlertForm';

export const QUALITY_ALERT_FORMS = {
  'nel-quality-alert': NelQualityAlertForm,
  'ncl-gp-feedback-alert': NclFeedbackAlertForm,
};
